<template>
  <div id="test-paper">
    <!-- 试卷编辑界面 -->
    <div class="type" v-for="(item, index) in data" :key="index">
      <div class="title">
        {{ transitionNumToText(index) }}、{{ transitionName(item.type) }}（{{
          item.item.length
        }}题 / {{ item.typeTotalPoints }}分）
      </div>
      <div class="item" v-for="(que, ii) in item.item" :key="ii">
        <div class="title">
          {{ que.index }}、<span v-html="que.questionStem"></span>
          <span class="nd"
            >（难度：<i
              :class="{
                'el-icon-star-off': true,
                'el-icon-star-on': que.gradeOfDifficulty >= s,
              }"
              v-for="s in 5"
              :key="s"
            ></i
            >）</span
          >
        </div>
        <div class="xx" v-if="item.type == '0' || item.type == '1'">
          <!-- 选择题的选项值 -->
          <div class="itel" v-for="(qo, iii) in que.questionOptions" :key="iii">
            {{ qo.title }}、<span v-html="qo.value"></span>
          </div>
        </div>
        <div class="op">
          <!-- 操作 -->
          <div class="va">
            <el-input v-model="que.points" placeholder="请输入分值"></el-input>
            <span>分</span>
          </div>
          <div class="but" @click="changeClick(que, ii, index, '0')">替换</div>
          <div class="but" @click="changeClick(que, ii, index, '1')">上移</div>
          <div class="but" @click="changeClick(que, ii, index, '2')">下移</div>
        </div>
      </div>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
      @handleClickChangePaper="handleClickChangePaper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as paperData from "../../views/admin/question_bank/js/question.js";
export default {
  name: "diy_dialog_paper",
  props: {
    paperData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      data: this.paperData,
      tempPaper: {},
      dialogData: {
        flag: false,
        title: "选择替换的试题",
        width: "40%",
        tempIndex: 0,
        tempTypeIndex: 0,
        dialogData: [
          {
            type: "select-html",
            value: "",
            title: "试题",
            options: [],
            placeholder: "请选择要替换的试题",
          },
        ],
        buttonList: [
          { text: "确定", active: "makesure_change_paper" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  watch: {
    paperData() {
      this.data = this.paperData;
    },
    data(newValue) {
      this.$emit("showPaper", this.data);
    },
  },
  methods: {
    /**
     * 小写数字转大写数字
     */
    transitionNumToText(num) {
      let text = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return text[num];
    },
    /**
     *
     */ transitionName(type) {
      return paperData.initTableValue("topic", type);
    },
    /**
     * 具体题目的操作
     * item:具体题目
     * itemIndex:题目所在的索引
     * typeIndex:题目类型所在的索引
     * flag:具体操作  0 替换  1 上移  2 下移
     */
    async changeClick(item, itemIndex, typeIndex, flag) {
      try {
        let temp = {};
        switch (flag) {
          case "0":
            // 替换试题
            console.log("要替换的当前试题:", item);
            this.tempPaper = JSON.parse(JSON.stringify(item));
            this.dialogData.tempIndex = itemIndex;
            this.dialogData.tempTypeIndex = typeIndex;
            let tempSubject = JSON.parse(sessionStorage.getItem("tempSubject"));
            let subject = [];
            tempSubject.forEach((element) => {
              subject.push(element.subjectId);
            });
            let requestData = {
              subject: subject,
              topicnType: this.data[typeIndex].type,
              type: "0", // 考试题库
              stem: "",
            };

            this.dialogData.dialogData = [
              { value: requestData, type: "change-test-paper" },
            ];
            this.dialogData.buttonList = [];
            this.dialogData.flag = true;
            break;
          case "1":
            // 上移
            if (itemIndex == 0) {
              throw { message: "当前试题已是当前类型的第一题,无法上移" };
            }
            temp = JSON.parse(JSON.stringify(item));
            temp.index--;
            this.data[typeIndex].item[itemIndex] = JSON.parse(
              JSON.stringify(this.data[typeIndex].item[itemIndex - 1])
            );
            this.data[typeIndex].item[itemIndex].index++;
            this.data[typeIndex].item[itemIndex - 1] = temp;
            this.$forceUpdate();
            break;
          case "2":
            // 下移
            if (itemIndex == this.data[typeIndex].item.length - 1) {
              throw { message: "当前试题已是当前类型的最后一题,无法下移" };
            }
            temp = JSON.parse(JSON.stringify(item));
            temp.index++;
            this.data[typeIndex].item[itemIndex] = JSON.parse(
              JSON.stringify(this.data[typeIndex].item[itemIndex + 1])
            );
            this.data[typeIndex].item[itemIndex].index--;
            this.data[typeIndex].item[itemIndex + 1] = temp;
            this.$forceUpdate();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.warning(error.message);
      }
    },
    async dialogOper(active) {
      try {
        switch (active) {
          case "cancel":
            this.colseDialog();
            break;
          case "makesure_change_paper":
            // 确定选择要替换的试题
            let id = this.dialogData.dialogData[0].value;
            if (id == "") {
              throw { message: "请先选择要替换的试题" };
            }
            let resultData = await this.$request({
              url: "/questionBank/getQuestionBankDetailsById",
              method: "post",
              data: { id: id },
            });
            this.tempPaper.knowledgePoint = resultData.knowledgePoint;
            this.tempPaper.questionAnswer = resultData.questionAnswer;
            this.tempPaper.questionId = id;
            this.tempPaper.questionOptions = resultData.questionOptions;
            this.tempPaper.questionStem = resultData.questionStem;
            this.tempPaper.gradeOfDifficulty = resultData.gradeOfDifficulty;
            this.data[this.dialogData.tempTypeIndex].item[
              this.dialogData.tempIndex
            ] = JSON.parse(JSON.stringify(this.tempPaper));
            this.dialogData.flag = false;
            this.$forceUpdate();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.warning(error.message);
      }
    },
    /**
     * 确定选择替换试题
     */
    async handleClickChangePaper(id) {
      let resultData = await this.$request({
        url: "/questionBank/getQuestionBankDetailsById",
        method: "post",
        data: { id: id },
      });
      this.tempPaper.knowledgePoint = resultData.knowledgePoint;
      this.tempPaper.questionAnswer = resultData.questionAnswer;
      this.tempPaper.questionId = id;
      this.tempPaper.questionOptions = resultData.questionOptions;
      this.tempPaper.questionStem = resultData.questionStem;
      this.tempPaper.gradeOfDifficulty = resultData.gradeOfDifficulty;
      this.data[this.dialogData.tempTypeIndex].item[
        this.dialogData.tempIndex
      ] = JSON.parse(JSON.stringify(this.tempPaper));
      this.dialogData.flag = false;
      this.$forceUpdate();
    },
    /**
     * 关闭弹出框
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
};
</script>

<style lang="less" scoped>
#test-paper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-color: #333;
  > .type {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    > .title {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 16px;
      font-weight: bold;
    }
    > .item {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #e9e9e9;
      box-sizing: border-box;
      margin-bottom: 20px;
      > .title {
        width: 100%;
        height: auto;
        line-height: 30px;
        display: flex;
        align-items: center;
        text-align: left;
        > .nd {
          margin-left: 10px;
          font-size: 14px;

          .el-icon-star-off {
            font-size: 15px;
            color: #e9e9e9;
          }
          .el-icon-star-on {
            color: #ffe710;
            font-size: 17px;
          }
        }
        /deep/ p {
          display: inline;
        }
      }
      > .xx {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        box-sizing: border-box;
        > .itel {
          width: 100%;
          height: auto;
          line-height: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 5px;
          font-size: 15px;
        }
      }
      > .op {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-bottom: 10px;
        > .va {
          width: 80px;
          margin-right: 10px;
          display: flex;
          font-size: 15px;
          align-items: center;
          > span {
            margin-left: 5px;
          }
        }
        > .but {
          width: auto;
          padding: 0 5px;
          box-sizing: border-box;
          font-size: 14px;
          color: #2187fc;
          transition: 0.3s;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }
      }
    }
  }
}
</style>